"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shoppingContextActions = void 0;
var AcceptNotification = _interopRequireWildcard(require("@ori-events/accept-notification"));
var AcceptNotificationFailed = _interopRequireWildcard(require("@ori-events/accept-notification-failed"));
var AddBackorderDemand = _interopRequireWildcard(require("@ori-events/add-backorder-demand"));
var AddBackorderDemandFailed = _interopRequireWildcard(require("@ori-events/add-backorder-demand-failed"));
var AddBasketOffer = _interopRequireWildcard(require("@ori-events/add-basket-offer"));
var AddBasketOfferFailed = _interopRequireWildcard(require("@ori-events/add-basket-offer-failed"));
var AddCatalogueOffer = _interopRequireWildcard(require("@ori-events/add-catalogue-offer"));
var AddCatalogueOfferFailed = _interopRequireWildcard(require("@ori-events/add-catalogue-offer-failed"));
var AddCustomerOrder = _interopRequireWildcard(require("@ori-events/add-customer-order"));
var AddCustomerOrderFailed = _interopRequireWildcard(require("@ori-events/add-customer-order-failed"));
var AddFreeShippingOffer = _interopRequireWildcard(require("@ori-events/add-free-shipping-offer"));
var AddFreeShippingOfferFailed = _interopRequireWildcard(require("@ori-events/add-free-shipping-offer-failed"));
var AddToBasket = _interopRequireWildcard(require("@ori-events/add-to-basket"));
var AddToBasketFailed = _interopRequireWildcard(require("@ori-events/add-to-basket-failed"));
var AddVoucher = _interopRequireWildcard(require("@ori-events/add-voucher"));
var AddVoucherFailed = _interopRequireWildcard(require("@ori-events/add-voucher-failed"));
var CancelBackorderDemand = _interopRequireWildcard(require("@ori-events/cancel-backorder-demand"));
var CancelSubscription = _interopRequireWildcard(require("@ori-events/cancel-subscription"));
var CancelSubscriptionFailed = _interopRequireWildcard(require("@ori-events/cancel-subscription-failed"));
var ClearBasket = _interopRequireWildcard(require("@ori-events/clear-basket"));
var DelaySubscription = _interopRequireWildcard(require("@ori-events/delay-subscription"));
var DelaySubscriptionFailed = _interopRequireWildcard(require("@ori-events/delay-subscription-failed"));
var DeleteOfferItem = _interopRequireWildcard(require("@ori-events/delete-offer-item"));
var DeleteOfferItemFailed = _interopRequireWildcard(require("@ori-events/delete-offer-item-failed"));
var RemoveBasketItem = _interopRequireWildcard(require("@ori-events/remove-basket-item"));
var RemoveBasketItemFailed = _interopRequireWildcard(require("@ori-events/remove-basket-item-failed"));
var RemoveCustomerOrder = _interopRequireWildcard(require("@ori-events/remove-customer-order"));
var RemoveCustomerOrderFailed = _interopRequireWildcard(require("@ori-events/remove-customer-order-failed"));
var RemoveShippingOfferItem = _interopRequireWildcard(require("@ori-events/remove-shipping-offer-item"));
var RemoveShippingOfferItemFailed = _interopRequireWildcard(require("@ori-events/remove-shipping-offer-item-failed"));
var RemoveVoucher = _interopRequireWildcard(require("@ori-events/remove-voucher"));
var RemoveVoucherFailed = _interopRequireWildcard(require("@ori-events/remove-voucher-failed"));
var ReplaceShoppingBagItem = _interopRequireWildcard(require("@ori-events/replace-shopping-bag-item"));
var ReplaceShoppingBagItemFailed = _interopRequireWildcard(require("@ori-events/replace-shopping-bag-item-failed"));
var ReplaceSubscription = _interopRequireWildcard(require("@ori-events/replace-subscription"));
var ReplaceSubscriptionFailed = _interopRequireWildcard(require("@ori-events/replace-subscription-failed"));
var RequestShoppingContext = _interopRequireWildcard(require("@ori-events/request-shopping-context"));
var ResetShippingSelection = _interopRequireWildcard(require("@ori-events/reset-shipping-selection"));
var ShoppingContextLoaded = _interopRequireWildcard(require("@ori-events/shopping-context-loaded"));
var UpdateBasketItem = _interopRequireWildcard(require("@ori-events/update-basket-item"));
var UpdateBasketItemFailed = _interopRequireWildcard(require("@ori-events/update-basket-item-failed"));
var UpdateCustomerOrderItem = _interopRequireWildcard(require("@ori-events/update-customer-order-item"));
var UpdateCustomerOrderItemFailed = _interopRequireWildcard(require("@ori-events/update-customer-order-item-failed"));
var UpdateDelivery = _interopRequireWildcard(require("@ori-events/update-delivery"));
var UpdateDeliveryChannel = _interopRequireWildcard(require("@ori-events/update-delivery-channel"));
var UpdateDeliveryChannelFailed = _interopRequireWildcard(require("@ori-events/update-delivery-channel-failed"));
var UpdateDeliveryFailed = _interopRequireWildcard(require("@ori-events/update-delivery-failed"));
var UpdateDonation = _interopRequireWildcard(require("@ori-events/update-donation"));
var UpdateDonationFailed = _interopRequireWildcard(require("@ori-events/update-donation-failed"));
var UpdateOfferItem = _interopRequireWildcard(require("@ori-events/update-offer-item"));
var UpdateOfferItemFailed = _interopRequireWildcard(require("@ori-events/update-offer-item-failed"));
var UpdateOfferItems = _interopRequireWildcard(require("@ori-events/update-offer-items"));
var UpdatePaymentProvider = _interopRequireWildcard(require("@ori-events/update-payment-provider"));
var UpdatePaymentProviderFailed = _interopRequireWildcard(require("@ori-events/update-payment-provider-failed"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/** Name / type of event which can trigger an action on current shopping context (loading, modification). */

/** Failed response event name / type for actions triggered on shopping context. */

/**
 * Success response event name / type for actions triggered on shopping context.
 * The event data is the same BasketUpdated.Data format.
 */

/**
 * Configuration of 1 particular shopping context action. For now contains
 * just the success & failed events. Might contain the handler code reference
 * for particular action and similar in the future.
 */

/**
 * Configuration of shopping context actions. Mapping of triggering events to response
 * success & failed events.
 */
const shoppingContextActions = exports.shoppingContextActions = new Map([[AcceptNotification.Name, {
  failedEvent: AcceptNotificationFailed.Name
}], [AddBackorderDemand.Name, {
  failedEvent: AddBackorderDemandFailed.Name
}], [AddBasketOffer.Name, {
  failedEvent: AddBasketOfferFailed.Name
}], [AddCatalogueOffer.Name, {
  failedEvent: AddCatalogueOfferFailed.Name
}], [AddCustomerOrder.Name, {
  failedEvent: AddCustomerOrderFailed.Name
}], [AddFreeShippingOffer.Name, {
  failedEvent: AddFreeShippingOfferFailed.Name
}], [AddToBasket.Name, {
  failedEvent: AddToBasketFailed.Name
}], [AddVoucher.Name, {
  failedEvent: AddVoucherFailed.Name
}], [CancelBackorderDemand.Name /* no failed event available so far */, {}], [CancelSubscription.Name, {
  failedEvent: CancelSubscriptionFailed.Name
}], [ClearBasket.Name /* no failed event available so far */, {}], [DelaySubscription.Name, {
  failedEvent: DelaySubscriptionFailed.Name
}], [DeleteOfferItem.Name, {
  failedEvent: DeleteOfferItemFailed.Name
}], [RemoveBasketItem.Name, {
  failedEvent: RemoveBasketItemFailed.Name
}], [RemoveCustomerOrder.Name, {
  failedEvent: RemoveCustomerOrderFailed.Name
}], [RemoveShippingOfferItem.Name, {
  failedEvent: RemoveShippingOfferItemFailed.Name
}], [RemoveVoucher.Name, {
  failedEvent: RemoveVoucherFailed.Name
}], [ReplaceShoppingBagItem.Name, {
  failedEvent: ReplaceShoppingBagItemFailed.Name
}], [ReplaceSubscription.Name, {
  failedEvent: ReplaceSubscriptionFailed.Name
}], [RequestShoppingContext.Name, {
  successEvent: ShoppingContextLoaded.Name
}], [ResetShippingSelection.Name /* no failed event available so far */, {}], [UpdateBasketItem.Name, {
  failedEvent: UpdateBasketItemFailed.Name
}], [UpdateCustomerOrderItem.Name, {
  failedEvent: UpdateCustomerOrderItemFailed.Name
}], [UpdateDelivery.Name, {
  failedEvent: UpdateDeliveryFailed.Name
}], [UpdateDeliveryChannel.Name, {
  failedEvent: UpdateDeliveryChannelFailed.Name
}], [UpdateDonation.Name, {
  failedEvent: UpdateDonationFailed.Name
}], [UpdateOfferItem.Name, {
  failedEvent: UpdateOfferItemFailed.Name
}], [UpdateOfferItems.Name /* no failed event available so far */, {}], [UpdatePaymentProvider.Name, {
  failedEvent: UpdatePaymentProviderFailed.Name
}]]);
